import React, { memo, useState, useCallback } from "react";
import { Text } from "@shopify/polaris";
import { ArrowDownIcon, ArrowUpIcon } from "@shopify/polaris-icons";
import { APP_DISPLAY_NAME, THEME_SECTION_BLOCK_NAME } from "../../config/appBranding";

const FAQ_ITEMS = [
  {
    q: `What does ${APP_DISPLAY_NAME} do?`,
    a: "It adds an events calendar to your online store so customers can see upcoming events — sales, launches, webinars, workshops, and in-store events — and register for them. You manage everything from your Shopify admin.",
  },
  {
    q: "Do I need to know how to code to use it?",
    a: "No. You create events, choose a layout, and adjust colors and fonts in a visual builder with a live preview. Adding the calendar to your store is done through the theme editor.",
  },
  {
    q: "How do I add the calendar to my store?",
    a: `Create a widget in the app and copy its Widget ID. In the theme editor, add the "${THEME_SECTION_BLOCK_NAME}" section block to a page, paste the Widget ID, and save.`,
  },
  {
    q: "What calendar layouts are available?",
    a: "Six styles: Classic month, Minimal month, Navy month, Soft list, Card grid, and Strip week. You can switch layouts at any time from the widget builder.",
  },
  {
    q: "Can customers register for an event?",
    a: 'Yes. Turn on registration per event to collect name, email, and optional phone or guest count. You can set a maximum number of spots — when full, visitors see an "event full" message. Signups appear on the Signups page in this app.',
  },
  {
    q: "Will it work with my theme?",
    a: "Yes. It uses Shopify theme app extensions (section blocks and app embed), so it works with Online Store 2.0 themes without editing theme code.",
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = useCallback((idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  }, []);

  return (
    <div className="age-faq-section">
      <Text as="h2" variant="headingLg">
        Frequently Ask Questions
      </Text>

      <div className="age-faq-list">
        {FAQ_ITEMS.map((item, idx) => {
          const open = openIndex === idx;
          return (
            <div key={item.q} className={`age-faq-item${open ? " age-faq-item--open" : ""}`}>
              <button
                type="button"
                className="age-faq-item__btn"
                onClick={() => toggle(idx)}
                aria-expanded={open}
              >
                <Text as="span" variant="bodyMd">
                  {idx + 1}. {item.q}
                </Text>
                <span className="age-faq-item__icon" aria-hidden>
                  {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </span>
              </button>
              {open ? (
                <div className="age-faq-item__answer">
                  <Text as="p" variant="bodySm" tone="subdued">
                    {item.a}
                  </Text>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(FaqSection);
